import React from 'react'
import { useDrag } from 'react-dnd'
import { learnerTypeAccentColor } from '../utils'

const QuestionCard = ({ id, text, learnerType, enabled }) => {
  const [{ isDragging }, drag, preview] = useDrag(
    () => ({
      type: 'question',
      item: { cardType: 'question', id, text, learnerType },
      collect: (monitor) => ({
        isDragging: monitor.isDragging(),
      }),
    }),
    [id, text, learnerType]
  )

  const learnerTypeColor = learnerTypeAccentColor(learnerType)
  const cursor = enabled ? 'pointer' : 'auto'
  const style = {
    cursor: isDragging ? 'move' : cursor,
    color: enabled ? undefined : '#c8c8c8',
  }

  const markup = (
    <div className="question-card" style={style} ref={drag}>
      <span dangerouslySetInnerHTML={{ __html: text }} />
      <span
        className="learner-type"
        style={{ color: learnerTypeColor }}
        dangerouslySetInnerHTML={{ __html: learnerType }}
      />
    </div>
  )

  return enabled ? <div ref={preview}>{markup}</div> : markup
}

export default QuestionCard
